<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kategori Adı <span class="text-danger">*</span></label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input class="form-control" v-model="value.Name" placeholder="Kategori Adı Giriniz..." />
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: true,
        },
    },
};
</script>
